<template>
  <router-view />
</template>

<script>
export default {
  name: 'LayoutsDemosBaselineFlipped',
  props: {
    source: String
  },
  data: () => ({
    isRouterViewVisible: false,
    drawer: null
  }),
  created () {
    this.loadPreData()
  },
  methods: {
    loadPreData () {
      this.$store.dispatch('auth/self').then(() => {
        this.$store.dispatch('auth/state')
      })
    }
  }
}
</script>

<style lang="scss">
@import '@/ox/src/styles/main';
@import '@/styles/main';
</style>
